/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, Button } from '@resultadosdigitais/tangram-components';

function AlertActions({ alertKey, actions }) {
  if (actions.length === 0) {
    return null;
  }

  return (
    <ButtonGroup>
      {actions.map((action, index) => (
        <Button key={`page-alert-action-${alertKey}-${index}`} {...action} />
      ))}
    </ButtonGroup>
  );
}

AlertActions.defaultProps = {
  alertKey: '',
  actions: [],
};

AlertActions.propTypes = {
  alertKey: PropTypes.string,
  actions: PropTypes.array,
};

export default AlertActions;
